import { render, staticRenderFns } from "./FollowStatistic.vue?vue&type=template&id=414744a2&scoped=true"
import script from "./FollowStatistic.vue?vue&type=script&lang=js"
export * from "./FollowStatistic.vue?vue&type=script&lang=js"
import style0 from "./FollowStatistic.vue?vue&type=style&index=0&id=414744a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414744a2",
  null
  
)

export default component.exports